import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense, useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { SubscriptionProvider, useSubscription } from './context/SubscriptionContext';
import UpgradePrompt from './components/UpgradePrompt';
import MainLayout from './layouts/MainLayout';

const Login         = lazy(() => import('./pages/Login'));
const Display       = lazy(() => import('./pages/Display'));
const DashboardHome = lazy(() => import('./pages/lpo/DashboardHome'));
const Priorities    = lazy(() => import('./pages/lpo/Priorities'));
const Personnel     = lazy(() => import('./pages/lpo/Personnel'));
const Selres        = lazy(() => import('./pages/lpo/Selres'));
const Reminders     = lazy(() => import('./pages/lpo/Reminders'));
const PassdownLog   = lazy(() => import('./pages/lpo/PassdownLog'));
const Programs      = lazy(() => import('./pages/lpo/Programs'));
const Notebook      = lazy(() => import('./pages/lpo/Notebook'));
const Awards        = lazy(() => import('./pages/lpo/Awards'));
const EvalBuilder   = lazy(() => import('./pages/lpo/EvalBuilder'));

const RouteFallback = (
  <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'var(--text-secondary)' }}>
    Loading...
  </div>
);

function PaidRoute({ children }) {
  const { isPaid, loading } = useSubscription();
  const [showUpgrade, setShowUpgrade] = useState(false);
  if (loading) return null;
  if (!isPaid) return (
    <>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column', gap:'16px', color:'var(--text-secondary)' }}>
        <p style={{ margin:0 }}>This feature requires LPODASH Pro.</p>
        <button
          onClick={() => setShowUpgrade(true)}
          style={{ background:'var(--gold)', color:'#000', border:'none', borderRadius:'8px', padding:'10px 20px', fontWeight:700, cursor:'pointer' }}>
          Upgrade
        </button>
      </div>
      {showUpgrade && <UpgradePrompt onClose={() => setShowUpgrade(false)} />}
    </>
  );
  return children;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'var(--text-secondary)' }}>Loading...</div>;
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <SubscriptionProvider>
          <BrowserRouter>
            <Suspense fallback={RouteFallback}>
              <Routes>
                <Route path="/display" element={<Display />} />
                <Route path="/login"   element={<Login />} />
                <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                  <Route index         element={<DashboardHome />} />
                  <Route path="priorities" element={<Priorities />} />
                  <Route path="personnel"  element={<Personnel />} />
                  <Route path="selres"     element={<Selres />} />
                  <Route path="reminders"  element={<Reminders />} />
                  <Route path="passdown"   element={<PassdownLog />} />
                  <Route path="programs"  element={<PaidRoute><Programs /></PaidRoute>} />
                  <Route path="notebook"  element={<PaidRoute><Notebook /></PaidRoute>} />
                  <Route path="awards"    element={<PaidRoute><Awards /></PaidRoute>} />
                  <Route path="evals"     element={<PaidRoute><EvalBuilder /></PaidRoute>} />
                </Route>
              </Routes>
            </Suspense>
          </BrowserRouter>
        </SubscriptionProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
